// TODO divide into modules
import {
  ApprovalRequest,
  Category,
  Department,
  Institution,
  LearningObject,
  PagerResponse,
  Procedure,
  Study,
  User,
  UserRole,
  GetMostPopularProceduresResponse,
  GetInfrequentProceduresResponse,
  GetNursesExperienceResponse,
  GetNurseAgeExperienceStatsResponse,
  GetNurseAgeStatsResponse,
  Patient,
  GetNurseExperienceStatsResponse,
  GetAverageShiftDataResponse,
  GetAveragePatientAcuityDataResponse,
  ShiftWithVisits,
  PatientVisit,
  Survey,
} from '@/generated/graphql';

class State {
  institutions: Array<Institution> = [];
  institutionPageInfo: PagerResponse = {};
  refreshInstitutions = false;
  currentUserIsActiveSub = false;
  localeOverride: string = null;
  currentUser: User = null;
  currentRoles: UserRole[] = [];
  impersonatedUser = false;
  procedures: Array<Procedure> = [];
  activeProcedure: Procedure = null;
  procedurePageInfo: PagerResponse = {};
  refreshProcedures = false;
  categoryList: Array<Category> = [];
  userPageInfo: PagerResponse = {};
  departmentsList: Department[] = [];
  refreshDepartments = false;
  studies: Study[] = [];
  studyResults: Survey[] = [];
  studyResultsPageInfo: PagerResponse = {};
  studyPageInfo: PagerResponse = {};
  activeStudy: Study = null;
  refreshStudies = false;
  learningObjectLists: LearningObject[] = [];
  refreshLearningObjects = false;
  learningObjectsPageInfo: PagerResponse = {};
  mostPopularProcedures: GetMostPopularProceduresResponse;
  infrequentsProcedures: GetInfrequentProceduresResponse;
  nursesExperience: GetNursesExperienceResponse;
  nurseAgeExperienceStats: GetNurseAgeExperienceStatsResponse;
  nurseAgeStats: GetNurseAgeStatsResponse;
  nurseSexStats: GetNurseExperienceStatsResponse;
  shiftAverageStats: GetAverageShiftDataResponse;
  acuityAverageStats: GetAveragePatientAcuityDataResponse;
  patientsPageInfo: PagerResponse = {};
  visitsPageInfo: PagerResponse = {};
  patientsList: Patient[] = [];
  fiveMostFrequentlyProcedures: any;
  fiveLeastFrequentlyProcedures: any;
  surveyResults: any;
  fiveMostAssistedProcedures: any;
  shiftIntensityChart: any;
  shiftTirednessChart: any;
  tableShowSize = 5;
  shiftVisits: ShiftWithVisits[] | PatientVisit[];
  nurseHistoryLocation: any;
  // Module states
  departments: {
    departments: any[];
    departmentsPageInfo: PagerResponse;
    refreshDepartments: boolean;
  };

  categories: {
    categories: any[];
    categoriesPageInfo: PagerResponse;
    refreshCategories: boolean;
  };

  users: {
    users: User[];
    userPageInfo: PagerResponse;
    activeSubUsers: number;
  };

  roles: {
    roles: any[];
  };

  approvalRequests: {
    approvalRequests: ApprovalRequest[];
    approvalRequestsPageInfo: PagerResponse;
    actionableCount: number;
  };
}

export default State;
